// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gnqx","tabsBox":"styles_tabsBox__XRgrf","createButton":"styles_createButton__3D6Wj"};